import React from 'react';
import classnames from 'classnames';
import Arrow from 'images/icon/direction-button-arrow.inline.svg';

import styles from './index.module.css';

interface DirectionButtonProperty {
	appear: 'filling' | 'border';
	direction: 'left' | 'right';
	handleClick: () => void;
	className?: string;
}

const DirectionButton: React.FC<DirectionButtonProperty> = ({
	appear,
	direction = 'left',
	handleClick = () => {},
	className,
}) => (
	<button
		type="button"
		onClick={handleClick}
		className={classnames(styles.directionButton, styles[appear], styles[direction], className)}
	>
		<Arrow />
	</button>
);

export default DirectionButton;
